import { Splide } from '@splidejs/splide';

// Drupal behavior for the Testimonial Slider block
(function (Drupal) {
  Drupal.behaviors.testimonialSlider = {
    attach(context: HTMLElement) {
      context.querySelectorAll('[data-testimonial-slider]').forEach((el) => {
        if (el.classList.contains('is-initialized')) return;

        const slides = el.querySelectorAll('.splide__slide');
        const slideCount = slides.length;

        const sliderEnabled = slideCount > 4;
        const showArrows = slideCount > 3;

        new Splide(el, {
          type: sliderEnabled ? 'loop' : 'slide',
          perPage: 3,
          perMove: 1,
          clones: sliderEnabled ? undefined : 0, // prevent clone creation
          autoplay: false,
          interval: 3000,
          gap: '30px',
          pagination: false,
          arrows: showArrows ? true : false,
          breakpoints: {
            1440: {
              perPage: 2,
              type: 'loop',
              arrows: 'true'
            },
            992: {
              perPage: 1,
              type: 'loop',
              arrows: 'true'
            },
            768: {
              gap: '17px',
              padding: '3rem',
              type: 'loop',
              arrows: 'true'
            }
          }
        }).mount();

        //console.info(sliderEnabled)

        if(!sliderEnabled) {
          const splideList = el.querySelector('.splide__track');
          if(splideList) {
            splideList.classList.add('no-slide');
          }
          el.classList.add('container');
        }

        el.classList.add('is-initialized');
      });
    },
  };
})(Drupal);
